/* 
Starting here and Continuing until Noted all code is provided with RESTRICTED RIGHTS:
Restricted Rights
Contract No.
BluePath Labs
2101 L St NW, Suite 800
Washington, DC 20037
The Government's rights to use, modify, reproduce, release, perform, display, or disclose this software are restricted by paragraph (b)(3) of the Rights in Noncommercial Computer Software and Noncommercial Computer Software Documentation clause contained in the above identified contract. Any reproduction of computer software or portions thereof marked with this legend must also reproduce the markings. Any person, other than the Government, who has been provided access to such software must promptly notify the above named Contractor.
*/
import BlueLensService from '@/api/bluelens';

const state = {
  mapData: [],
  search: null,
};
const getters = {
  mapData: (state) => {
    if (state.search) {
      // Method to check value against search string
      const searchMatch = (val) =>
        val &&
        val.toString().toLowerCase().includes(state.search.toLowerCase());

      // Filter mapData based on search value
      return state.mapData.filter((data) => {
        // Data properties included in search
        const { city, district, province, country, names, type, concepts } =
          data;
        // console.log(concepts);
        // Right now we only have one name and type, but this could change as we build the data out. If it does change and we don't handle with ElasticSearch, we'll need to consider updating this on the frontend.
        const primaryName = names[0];
        const primaryType = type[0];
        // Type is a string, return right away if it matches
        if (searchMatch(primaryType)) return true;
        // Other values are nested within objects - iterate and check for matches
        const objs = [city, district, province, country, primaryName];
        for (const obj of objs) {
          for (const value of Object.values(obj)) {
            if (searchMatch(value)) return true;
          }
        }
        // concepts is an array
        for (const concept of concepts) {
          if (searchMatch(concept)) {
            return true;
          }
        }
        return false;
      });
    }
    // If no search value, return all data
    return state.mapData;
  },
  search: (state) => state.search,
};
const actions = {
  // Fetch map data from API
  async getMapData({ commit }, payload) {
    const response = await BlueLensService.fetchOrganizationData(payload);
    if (response && response.data) {
      const data = Object.freeze(response.data);
      commit('setMapData', data);
    }
  },
};
const mutations = {
  setMapData(state, payload) {
    state.mapData = payload;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
/*
Ending here, all code as noted above is provided with RESTRICTED RIGHTS:
Restricted Rights
Contract No.
BluePath Labs
2101 L St NW, Suite 800
Washington, DC 20037
The Government's rights to use, modify, reproduce, release, perform, display, or disclose this software are restricted by paragraph (b)(3) of the Rights in Noncommercial Computer Software and Noncommercial Computer Software Documentation clause contained in the above identified contract. Any reproduction of computer software or portions thereof marked with this legend must also reproduce the markings. Any person, other than the Government, who has been provided access to such software must promptly notify the above named Contractor.
*/
